module.exports = __webpack_public_path__ + "static/img/fingerpost_order_2.3661fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_order_2.jpg
// module id = Ot9D
// module chunks = 0